(function () {
    $ (function () {
        const btnShownOffset = 1000; // величина скролла, после которой кнопка будет показана
        
        $ (".js-btn-to-top").each (function () {
            const $btn = $ (this);
            
            let scrTopPrev = $ (document).scrollTop ();
            
            let isBreakpointScrolled = false;
            let isShown = false;
            
            // --- инициализация
            
            handleBtnPos (true);
            
            
            // --- события
            
            $ (document).on ("scroll", function () {
                handleBtnPos ();
            });
            
            $btn.on ("click", function (e) {
                e.preventDefault ();
                
                window.scrollTo ({top: 0, behavior: 'smooth'});
            });
            
            
            // --- функции
            
            function handleBtnPos (onInit = false) {
                const scrTop = $ (document).scrollTop ();
                const dirIsDown = scrTop > scrTopPrev; // скролл движется вниз?
                
                const prevFlag = isBreakpointScrolled;
                
                isBreakpointScrolled = (scrTop >= btnShownOffset); // проскроллен ли брейкпойнт?
                
                
                // --- управляем состоянием
                
                // инициализация при отсутствии предыдущего скролла
                if (onInit && isBreakpointScrolled) {
                    handleState (true);
                }
                
                // если проскроллили брейкпойнт в любом направлении
                if (!onInit && prevFlag !== isBreakpointScrolled) {
                    let param = false;
                    
                    // если скроллится вниз, положение находится ниже брейкпойнта и кнопка не показана
                    if (dirIsDown && isBreakpointScrolled && !isShown) {
                        param = true;
                    }
                    
                    handleState (param);
                }
                
                scrTopPrev = scrTop;
            }
            
            function handleState (setOn = true) {
                
                if (setOn) {
                    $btn.addClass ("_shown");
                } else {
                    $btn.removeClass ("_shown");
                }
                
                isShown = setOn;
            }
        });
        
        // отправка события клика по кнопкам приложений
        
        $ (document).on ("click", ".js-btn-appmarket", function (e) {
            const $btn = $ (this);
            
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'appmarketClick',
                    data: {
                        url: globalFunctions.escapeStr (window.location.href), // если без get-параметров, то window.location.origin + window.location.pathname
                        type: globalFunctions.escapeStr ($btn.data ("type"))
                    }
                }
            ]);
        });
    })
} ());
